import styled from 'styled-components';
import { Text } from 'components/Base/Typography';

export const TAgeWrapper = styled(Text)`
  span {
    color: ${({ theme }) => theme.colorGreenFlyer};
  }
`;
